/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ModerationDefs from './defs.defs.js'

const $nsid = 'tools.ozone.moderation.getSubjects'

export { $nsid }

/** Get details about subjects. */
const main = l.query(
  $nsid,
  l.params({ subjects: l.array(l.string(), { maxLength: 100, minLength: 1 }) }),
  l.jsonPayload({
    subjects: l.array(
      l.ref<ModerationDefs.SubjectView>(
        (() => ModerationDefs.subjectView) as any,
      ),
    ),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
